import { CandleStickIcon, ListAltIcon, SwapHorizalIcon } from '@/icons';
import { useAddress } from '@/store/selector';
import { useTradeStore } from '@/store/trade-store';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { useShallow } from 'zustand/shallow';

const nav_data = [
    {
        title: 'Market',
        icon: <CandleStickIcon className="w-7 h-7" />,
        href: '/market',
    },
    {
        title: 'Trade',
        icon: <SwapHorizalIcon className="w-7 h-7" />,
        href: '/future',
    },

    {
        title: 'Order',
        icon: <ListAltIcon className="w-7 h-7" />,
        href: '/orders',
    },
];

export function NavigationView() {
    const address = useAddress();
    const { t } = useTranslation();

    const { count } = useTradeStore(
        useShallow((state) => ({ count: state.count }))
    );

    return (
        <nav
            className={clsx(
                'bottom-0 w-full bg-white border-t border-slate-200 pb-safe-bottom z-50 pb-3',
                'grid grid-cols-3 sticky'
            )}
        >
            {nav_data.map((item, idx) => {
                return (
                    <NavLink
                        to={address ? item.href : '/'}
                        key={idx}
                        className={({ isActive }) => {
                            return clsx(
                                'flex flex-col items-center justify-center transition-all py-2',
                                {
                                    'text-slate-900': isActive,
                                    'text-slate-400 hover:text-slate-600':
                                        !isActive,
                                }
                            );
                        }}
                    >
                        <div className="relative pl-1">
                            {item.icon}{' '}
                            {!!count.openTrade && item.title === 'Order' ? (
                                <p className="absolute bg-[#1966F7] rounded-[5px] text-xs px-1 text-white leading-[16px] top-[-5px] right-0">
                                    {count.openTrade}
                                </p>
                            ) : null}
                        </div>
                        <p className="text-xs font-medium">{t(item.title)}</p>
                    </NavLink>
                );
            })}
        </nav>
    );
}
